import React from 'react';
import ErrorBoundary from './ErrorBoundary';
import useAsyncData from '../hooks/useAsyncData';
import useStaleWarning from '../hooks/useStaleWarning';
import useAutoRefresh from '../hooks/useAutoRefresh';

const PipelineDisplay = () => {
  const { data: pipeline, loading, error, retry } = useAsyncData('/api/pipeline');
  const { isStale, lastUpdated } = useStaleWarning(pipeline);
  useAutoRefresh(retry);

  const fmtTime = (d) => d ? d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '–';

  if (loading) {
    return (
      <ErrorBoundary>
        <section className="panel pipeline-panel" aria-busy="true">
          <h2>Pipeline</h2>
          <div className="skeleton">
            <div className="skeleton-line" />
            <div className="skeleton-line" />
          </div>
        </section>
      </ErrorBoundary>
    );
  }

  if (error) {
    return (
      <ErrorBoundary>
        <section className="panel pipeline-panel" aria-live="assertive">
          <h2>Pipeline</h2>
          <p className="error-msg">Failed to load pipeline stages.</p>
          <button type="button" className="btn-retry" onClick={retry}>Retry</button>
        </section>
      </ErrorBoundary>
    );
  }

  return (
    <ErrorBoundary>
      <section className="panel pipeline-panel" aria-label="Pipeline stages" aria-busy="false">
        <div className="panel-header">
          <h2>Pipeline</h2>
          <div className="panel-meta">
            <span className="last-updated" aria-label="Last updated">
              Last updated: {fmtTime(lastUpdated)}
            </span>
            {isStale && (
              <span className="badge badge-stale" role="status">Stale</span>
            )}
            <button type="button" className="btn-icon btn-refresh" onClick={retry} aria-label="Refresh pipeline">
              ↻
            </button>
          </div>
        </div>
        <ol className="pipeline-stages" aria-label="Delivery pipeline stages">
          {(pipeline || []).length === 0 && <li className="empty">No pipeline stages reported</li>}
          {(pipeline || []).map((stage) => (
            <li className="stage" key={stage}>{stage}</li>
          ))}
        </ol>
      </section>
    </ErrorBoundary>
  );
};

export default PipelineDisplay;
